import React from "react";
import { useLang } from "../../context/LanguageContext";
import { SectionHeading } from "../motion/SectionHeading";
import { Stagger, StaggerItem } from "../motion/Reveal";
import { PackageCard } from "../cards/PackageCard";

export const PackagesPreview = ({ packages = [] }) => {
  const { t } = useLang();
  return (
    <section className="py-10 sm:py-14 bg-lightgray" data-testid="packages-section">
      <div className="max-w-[1300px] mx-auto px-5 sm:px-8">
        <SectionHeading title={t.packages.title} center />
        <Stagger className="grid grid-cols-3 gap-0 lg:gap-8 mt-8 sm:mt-10 items-center">
          {packages.map((p) => (
            <StaggerItem key={p.id || p.slug}>
              <PackageCard pkg={p} />
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
